/* Mobile Navigation v2.0.0
 * Provides an extendable mobile navigation menu.
 * Pass your arguments to the constructor, you need "blackout", one or more "togglers", and the "nav" itself
 * This class depends on CSS transitions.
 */

import * as $ from "jquery";

import GEModal from "./GEModal";

export default class MobileNav extends GEModal {
	toggler: JQuery = null;
	nav: JQuery = null;

	constructor(toggler: JQuery, nav: JQuery) {
		super(nav);

		const self = this;

		this.toggler = toggler;
		this.nav = nav;

		this.toggler.click(function() {
			self.toggle();
		});
	}

	setActive(active: boolean) {
		if (active) {
			this.show();
		} else {
			this.hide();
		}
	}
}